import { FormStore } from "../../review-portal/store/form.store";
import { hydrateAnswers } from "../../review-portal/utilities/FormUtils";
import { fetchAllSites, getFormTemplateById } from "../api-service";
import API from "../http-helper.service";

export default class FormFillerService {
  constructor() {
    this.state = {
      config: { includeUserId: true },
    };
  }
  getAllSites() {
    return fetchAllSites().then(
      (res) => {
        let sites = [];
        if (res.sites) {
          // Commented out to show all sites regardless of lifeCycleStatus (Operational + Commissioning, etc.)
          // sites = res.sites.filter(function (site) {
          //   return site.lifeCycleStatus === "Operational";
          // });
          sites = res.sites;
        }
        return sites;
      },
      (error) => {
        return error;
      },
    );
  }

  async getForm(formDataId) {
    try {
      const isNoSQL = FormStore.sharedInstance().getIsNoSQLForm();
      const response = await API.get(
        `filler/formData/formAnswer/${formDataId}`,
        {
          includeUserId: true,
          ...(isNoSQL && { baseUrlv4: true }),
        },
      );
      const answerData = hydrateAnswers(response.data);
      const formId = answerData?.formId;
      if (!formId) {
        throw new Error("formId not found in form answer response");
      }
      const formTemplate = await getFormTemplateById(formId);
      return { formTemplate, answerData };
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error;
    }
  }
  deleteForm(formId) {
    let baseUrl = "filler/formData/delete-formdata?id=" + formId + "";
    let data = {};
    return API.put(baseUrl, data, this.state.config).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  approveForm(formObject) {
    let baseUrl = "filler/formData/approve-or-reject";
    return API.put(baseUrl, formObject, this.state.config).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  rejectForm(formObject) {
    let baseUrl = "filler/formData/approve-or-reject";
    return API.put(baseUrl, formObject, this.state.config).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  validateGeIdTag(formDataId, geIdTag, updateFlag = false) {
    const trimmedGeIdTag = geIdTag ? geIdTag.trim() : geIdTag;
    const baseUrl = `filler/formData/${formDataId}/validateIdTag?geIdTag=${trimmedGeIdTag}${updateFlag ? "&updateFlag=true" : ""}`;
    return API.get(baseUrl, this.state.config)
      .then((res) => res)
      .catch((err) => {
        const error = err.response ? err.response : err;
        throw error;
      });
  }

  validatePromptIdTag(
    formDataId,
    updateFlag = false,
    aiVerification = true,
  ) {
    const baseUrl = `filler/formData/${formDataId}/validateIdTag?updateFlag=${updateFlag}&aiVerification=${aiVerification}`;
    return API.get(baseUrl, this.state.config)
      .then((res) => res)
      .catch((err) => {
        const error = err.response ? err.response : err;
        throw error;
      });
  }

  downloadForm(formId) {
    let baseUrl = "filler/formData/" + formId + "/pdf";
    return API.get(baseUrl, {
      ...this.state.config,
      responseType: "blob",
    }).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  downloadBatchForms(formIds) {
    let baseUrl = "filler/formData/pdf/bulk/process";
    return API.post(baseUrl, { recordIds: formIds }, {
      ...this.state.config,
    }).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  downloadSelectedForms(formIds) {
    let baseUrl = "filler/formData/downloadZip?id=" + formIds;
    return API.get(baseUrl, {
      ...this.state.config,
      responseType: "blob",
    }).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  saveForm(id, form) {
    let baseUrl = `filler/formData/${id}?isFormBuilderUpdate=true`;
    const noSQLId = form.formDataNOSQLId;
    const config = {
      ...this.state.config,
      ...(noSQLId && { baseUrlv4: true }),
    };
    return API.put(baseUrl, form, config).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  saveQuestionCommentsMock(formDataId, elementId, notes) {
    return Promise.resolve({
      status: 200,
      data: {
        formDataId,
        elementId,
        notes,
      },
      mock: true,
    });
  }
}
